// Copyright (c) 2016 Deere & Company

import PipDetails, {getDefaultState as getPipDetailsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-details';
import actions from '../../actions-list';

const readPipDetails = (state, action) =>
    PipDetails.update(state, {
        $set: action.data
    });

const resetPipDetails = () => getPipDetailsDefaultState();

export default (state = getPipDetailsDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_PIP_DETAILS_SUCCESS]: readPipDetails,
        [actions.RESET_PIP_DETAILS]: resetPipDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-details/reducers/pip-details.js